<div class="bo-auth-input">
  <label class="bo-auth-input__label" [attr.for]="inputId()">{{ label() }}</label>
  <div class="bo-auth-input__field" [class.bo-auth-input__field--invalid]="control().invalid && control().touched">
    @if (hasIcon()) {
      <span class="bo-auth-input__icon" aria-hidden="true">
        <ng-content select="[icon]"></ng-content>
      </span>
    }
    <input
      class="bo-auth-input__native"
      [class.bo-auth-input__native--with-icon]="hasIcon()"
      [class.bo-auth-input__native--with-suffix]="hasSuffix()"
      [id]="inputId()"
      [type]="inputType()"
      [placeholder]="placeholder()"
      [autocomplete]="autocomplete()"
      [formControl]="control()"
    />
    @if (hasSuffix()) {
      <span class="bo-auth-input__suffix">
        <ng-content select="[suffix]"></ng-content>
      </span>
    }
  </div>
  @if (control().invalid && control().touched) {
    <p class="bo-auth-input__error" role="alert">
      @if (control().errors?.['required']) {
        Este campo es obligatorio
      } @else if (control().errors?.['email']) {
        Ingresa un correo valido
      } @else if (control().errors?.['minlength']) {
        Minimo {{ control().errors?.['minlength'].requiredLength }} caracteres
      } @else if (control().errors?.['passwordMismatch']) {
        Las contrasenas no coinciden
      } @else {
        {{ customErrorMessage() }}
      }
    </p>
  }
</div>
